import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({ baseURL: API_BASE, headers: { 'Content-Type': 'application/json' } });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      const refresh = localStorage.getItem('refresh_token');
      if (refresh) {
        try {
          const { data } = await axios.post(`${API_BASE}/auth/refresh/`, { refresh });
          localStorage.setItem('access_token', data.access);
          if (data.refresh) localStorage.setItem('refresh_token', data.refresh);
          orig.headers.Authorization = `Bearer ${data.access}`;
          return api(orig);
        } catch {
          localStorage.clear();
          const next = encodeURIComponent(window.location.pathname);
          window.location.href = `/login?next=${next}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username, password) => api.post('/auth/login/', { username, password }),
  me: () => api.get('/auth/me/'),
  changePassword: (old_password, new_password) => api.post('/auth/change-password/', { old_password, new_password }),
};

// Resumes — use recno as the lookup
export const resumeAPI = {
  list: (params) => api.get('/resumes/', { params }),
  get: (recno) => api.get(`/resumes/${recno}/`),
  create: (data) => api.post('/resumes/', data),
  update: (recno, data) => api.put(`/resumes/${recno}/`, data),
  patch: (recno, data) => api.patch(`/resumes/${recno}/`, data),
  delete: (recno) => api.delete(`/resumes/${recno}/`),
  stats: () => api.get('/resumes/stats/'),
  exportEmails: (params) => api.get('/resumes/export_emails/', { params }),
};

export const filterAPI = { options: () => api.get('/filter-options/') };

export const emailAPI = {
  send: (data) => api.post('/email/send/', data),
};

export const historyAPI = { list: (params) => api.get('/history/', { params }) };

export const userAPI = {
  list: () => api.get('/users/'),
  get: (id) => api.get(`/users/${id}/`),
  create: (data) => api.post('/users/', data),
  update: (id, data) => api.put(`/users/${id}/`, data),
  delete: (id) => api.delete(`/users/${id}/`),
  resetPassword: (id, new_password) => api.post(`/users/${id}/reset-password/`, { new_password }),
};

export default api;
